import { Admin, Resource } from 'react-admin';
import { authProvider } from '../../shared/utils/authProvider';
import Layout from '../../widgets/Layout/ui/Layout/Layout';
import { UsersList } from '../../pages/Users/ui/UsersList/UsersList';
import { Resources } from '../../shared/types/Resources';
import { dataProvider } from '../../shared/utils/dataProvider';
import { UserShow } from '../../pages/Users/ui/UserShow/UserShow';
import { UserCreate } from '../../pages/Users/ui/UserCreate/UserCreate';
import { UserEdit } from '../../pages/Users/ui/UserEdit/UserEdit';
import { AuthProvider } from '../model/AuthProvider';
import { HashRouter } from 'react-router-dom';
// import { PromptList } from '../../pages/Prompt/ui/PromptList/PromptList';
// import { PromptCreate } from '../../pages/Prompt/ui/PromptCreate/PromptCreate';
import { FilesList } from '../../pages/Files/ui/FilesList/FilesList';
import { FileEdit } from '../../pages/Files/ui/FileEdit/FileEdit';
import { FileCreate } from '../../pages/Files/ui/FileCreate/FileCreate';
// import { HistoryList } from '../../pages/History/ui/HistoryList/HistoryList';
// import { ProductList } from '../../pages/Product/ui/ProductList/ProductList';
// import { ProductCreate } from '../../pages/Product/ui/ProductCreate/ProductCreate';
// import { ProductShow } from '../../pages/Product/ui/ProductShow/ProductShow';
// import { ProductEdit } from '../../pages/Product/ui/ProductEdit/ProductEdit';
import { Dashboard } from '../../pages/Dashboard/Dashboard';
// import { ChatList } from '../../pages/Chat/ui/ChatList/ChatList';
// import { ChatCreate } from '../../pages/Chat/ui/ChatCreate/ChatCreate';
// import { ChatShow } from '../../pages/Chat/ui/ChatShow/ChatShow';
// import { ChatEdit } from '../../pages/Chat/ui/ChatEdit/ChatEdit';
import { ModelList } from '../../pages/Model/ui/ModelList/ModelList';
import { ModelCreate } from '../../pages/Model/ui/ModelCreate/ModelCreate';
import { ModelShow } from '../../pages/Model/ui/ModelShow/ModelShow';
import { ModelEdit } from '../../pages/Model/ui/ModelEdit/ModelEdit';

import { FeedShow } from '../../pages/Feed/FeedShow';
import { FeedList } from '../../pages/Feed/FeedList';
import { FeedCreate } from '../../pages/Feed/FeedCreate';
import { FeedEdit } from '../../pages/Feed/FeedEdit';
import { MaterialShow } from '../../pages/Materials/MaterialShow';
import { MaterialList } from '../../pages/Materials/MaterialList';
import { MaterialCreate } from '../../pages/Materials/MaterialCreate';
import { MaterialEdit } from '../../pages/Materials/MaterialEdit';
import { MaterialTestsShow } from '../../pages/MaterialTests/MaterialTestsShow';
import { MaterialTestsList } from '../../pages/MaterialTests/MaterialTestsList';
import { MaterialTestsCreate } from '../../pages/MaterialTests/MaterialTestsCreate';
import { MaterialTestsEdit } from '../../pages/MaterialTests/MaterialTestsEdit';
import { TrendShow } from '../../pages/Trends/TrendShow';
import { TrendList } from '../../pages/Trends/TrendList';
import { TrendCreate } from '../../pages/Trends/TrendCreate';
import { TrendEdit } from '../../pages/Trends/TrendEdit';
import { ProductShow } from '../../pages/Products/ProductShow';
import { ProductCreate } from '../../pages/Products/ProductCreate';
import { ProductEdit } from '../../pages/Products/ProductEdit';
import { ProductList } from '../../pages/Products/ProductList';

// import { CategoryList } from '../../pages/Category/ui/CategoryList/CategoryList';
// import { CategoryShow } from '../../pages/Category/ui/CategoryShow/CategoryShow';
// import { CategoryCreate } from '../../pages/Category/ui/CategoryCreate/CategoryCreate';
// import { CategoryEdit } from '../../pages/Category/ui/CategoryEdit/CategoryEdit';
// import { InsalesList } from '../../pages/Insales/ui/InsalesList/InsalesList';
// import { InsalesCreate } from '../../pages/Insales/ui/InsalesCreate/InsalesCreate';
// import { InsalesEdit } from '../../pages/Insales/ui/InsalesEdit/InsalesEdit';
// import { InsalesShow } from '../../pages/Insales/ui/InsalesShow/InsalesShow';

function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <Admin
          dashboard={Dashboard}
          authProvider={authProvider}
          layout={Layout}
          dataProvider={dataProvider}
        >
          <Resource
            name={Resources.models}
            list={ModelList}
            create={ModelCreate}
            edit={ModelEdit}
            show={ModelShow}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Список моделей' }}
          />
          {/* <Resource
            name={Resources.chats}
            list={ChatList}
            create={ChatCreate}
            edit={ChatEdit}
            show={ChatShow}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Список чатов' }}
          />

          <Resource
            name={Resources.prompt}
            options={{ label: 'Промпт' }}
            list={PromptList}
            create={PromptCreate}
          /> */}

          <Resource
            name={Resources.files}
            list={FilesList}
            edit={FileEdit}
            hasEdit
            create={FileCreate}
            options={{ label: 'Файлы' }}
          />

          <Resource
            name={Resources.users}
            show={UserShow}
            list={UsersList}
            create={UserCreate}
            edit={UserEdit}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Пользователи' }}
          />

          <Resource
            name={Resources.feeds}
            show={FeedShow}
            list={FeedList}
            create={FeedCreate}
            edit={FeedEdit}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Ленты' }}
          />

          <Resource
            name={Resources.materials}
            show={MaterialShow}
            list={MaterialList}
            create={MaterialCreate}
            edit={MaterialEdit}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Материалы' }}
          />

          <Resource
            name={Resources.material_tests}
            show={MaterialTestsShow}
            list={MaterialTestsList}
            create={MaterialTestsCreate}
            edit={MaterialTestsEdit}
            hasCreate
            // hasShow
            hasEdit
            options={{ label: 'Тесты' }}
          />

          <Resource
            name={Resources.digests}
            show={TrendShow}
            list={TrendList}
            create={TrendCreate}
            edit={TrendEdit}
            hasCreate
            // hasShow
            hasEdit
            options={{ label: 'Тренды' }}
          />

          <Resource
            name={Resources.products}
            list={ProductList}
            create={ProductCreate}
            edit={ProductEdit}
            show={ProductShow}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Список продуктов' }}
          />
          {/* <Resource
            name={Resources.history}
            list={HistoryList}
            create={UserCreate}
            edit={UserEdit}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'История запросов' }}
          />
          <Resource
            name={Resources.product}
            list={ProductList}
            create={ProductCreate}
            edit={ProductEdit}
            show={ProductShow}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Список продуктов' }}
          />
          <Resource
            name={Resources.categories}
            list={CategoryList}
            create={CategoryCreate}
            edit={CategoryEdit}
            show={CategoryShow}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Список категорий' }}
          />
          <Resource
            name={Resources.insales}
            list={InsalesList}
            create={InsalesCreate}
            edit={InsalesEdit}
            show={InsalesShow}
            hasCreate
            hasShow
            hasEdit
            options={{ label: 'Список Insales интеграций' }}
          />
          <Resource
            name={Resources.insales_products}
            // list={InsalesProductList}
            // show={InsalesProductShow}
            hasShow
            options={{ label: 'Список Insales продуктов' }}
          /> */}
        </Admin>
      </AuthProvider>
    </HashRouter>
  );
}

export default App;
